import { gql } from '@apollo/client';

import DOCUMENTS_FRAGMENT from '../fragments/documents';

export const UPDATE_DOCUMENT = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation updateDocumentEntity($updatedDoc: DocumentInput!, $filter: DocumentInput!) {
    updateDocumentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...DocumentsFragment
    }
  }
`;

export const CREATE_DOCUMENT = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation createDocumentEntity($doc: DocumentInput!) {
    createDocumentEntity(doc: $doc) {
      ...DocumentsFragment
    }
  }
`;

export const DELETE_DOCUMENT = gql`
  mutation deleteDocumentEntity($id: String!) {
    deleteDocumentEntity(id: $id) {
      message
    }
  }
`;

export const UPDATE_MANY_DOCUMENTS = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation updateManyDocumentEntity($updatedDoc: [DocumentInput!]!, $filter: [DocumentInput!]!) {
    updateManyDocumentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...DocumentsFragment
    }
  }
`;

export const CREATE_MANY_DOCUMENTS = gql`
  ${DOCUMENTS_FRAGMENT}
  mutation createManyDocumentEntity($doc: [DocumentInput!]!) {
    createManyDocumentEntity(doc: $doc) {
      ...DocumentsFragment
    }
  }
`;

export const DELETE_MANY_DOCUMENTS = gql`
  mutation deleteManyDocumentEntity($ids: [String!]!) {
    deleteManyDocumentEntity(updatedDoc: $updatedDoc, filter: $filter) {
      message
    }
  }
`;
